<div class="bigger-container">
  <div class="left-section">
    <p [ngClass]="{ selected: step === 0 }" (click)="changeTab(0)">
      Anagrafica
    </p>
    <p [ngClass]="{ selected: step === 1 }" (click)="changeTab(1)">
      Formazione
    </p>
  </div>
  <div class="right-section">
    <div class="back-button" (click)="goBack()">
      <i class="material-icons">arrow_back</i>
      <p>Torna alla lista</p>
    </div>
    <div class="smaller-container">
      <p class="smaller-text">
        {{ isNew ? "Crea" : "Modifica" }} Nutrizionista
      </p>
      <div class="smaller-bar"></div>
    </div>
    <form [formGroup]="form" class="mt-5 px-3">
      <!-- -INFO -->
      <div *ngIf="step === 0" class="grid" formGroupName="info">
        <div>
          <label class="label" for="name">Nome<span class="red">*</span></label>
          <input type="text" id="name" formControlName="name" />
        </div>
        <div>
          <label class="label" for="surname"
            >Cognome<span class="red">*</span></label
          >
          <input type="text" id="surname" formControlName="surname" />
        </div>
        <div>
          <label class="label" for="email"
            >Email<span class="red">*</span></label
          >
          <input type="text" id="email" formControlName="email" />
        </div>
        <div>
          <label class="label" for="phone"
            >Cellulare<span class="red">*</span></label
          >
          <input type="text" id="phone" formControlName="phone" />
        </div>
        <div>
          <label class="label" for="age">Età</label>
          <input
          readonly
            type="number"
            id="age"
            formControlName="age"
            min="0"
            max="99"
          />
        </div>
        <div>
          <label class="label" for="birthDate">Data di Nascita</label>
          <input type="date" id="birthDate" formControlName="birthDate" />
        </div>
        <div>
          <label class="label" for="fiscalcode">Codice Fiscale</label>
          <input
            type="text"
            id="fiscalcode"
            style="text-transform: uppercase"
            formControlName="fiscalcode"
          />
        </div>
        <div>
          <label class="label" for="iban">IBAN</label>
          <input type="text" id="iban" formControlName="iban" />
        </div>
        <div>
          <label class="label">Video</label>
          <input type="text" formControlName="video" />
        </div>
        <div>
          <label class="label">Certificato</label>
          <div>
            <a
              [href]="nutritionist && nutritionist.certificate"
              *ngIf="
                nutritionist &&
                nutritionist.certificate &&
                nutritionist.certificate !== ''
              "
              target="_blank"
              class="tertiary-button"
              >Scarica</a
            >
            <p
              *ngIf="
                !nutritionist ||
                !nutritionist.certificate ||
                nutritionist.certificate === ''
              "
              style="grid-column: 1/3"
            >
              Il nutrizionista non ha ancora ottenuto la certificazione.
            </p>
          </div>
        </div>
        <div>
          <label class="label">Documenti</label>
          <div>
            <div class="upload-button-container" style="display: block">
              <button class="secondary-button">Carica</button>
              <input
                type="file"
                accept=".pdf"
                (change)="uploadFile($event, 'info.resume')"
              />
            </div>
            <a
              *ngIf="
                nutritionist
                  ? nutritionist.info
                    ? nutritionist.info.resume
                    : false
                  : false
              "
              class="tertiary-button"
              download
              [href]="
                nutritionist
                  ? nutritionist.info
                    ? nutritionist.info.resume
                    : ''
                  : ''
              "
              target="_blank"
              >Scarica</a
            >
          </div>
        </div>
        <div *ngIf="!isNew; else elseBlock">
          <label class="label">Foto</label>
          <div>
            <div class="upload-button-container" style="display: block">
              <button class="secondary-button">Carica</button>
              <input
                id="image-selection"
                type="file"
                accept="image/*"
                (change)="openModal($event)"
              />
            </div>
            <a
              *ngIf="
                nutritionist
                  ? nutritionist.info
                    ? nutritionist.info.photo
                    : false
                  : false
              "
              class="tertiary-button"
              download
              [href]="
                nutritionist
                  ? nutritionist.info
                    ? nutritionist.info.photo
                    : ''
                  : ''
              "
              target="_blank"
              >Scarica</a
            >
          </div>
        </div>
        <ng-template #elseBlock>
          <div>
            <label class="label">Foto</label>
            <p id="foto">
              Puoi aggiungere la foto nella sezione "modifica" del profilo
            </p>
          </div>
        </ng-template>

        <div *ngIf="nutritionist !== undefined">
          <label class="label" for="subInterest">ID nutrizionista:</label>
          <p style="font-weight: bold">{{ nutritionist.docRef }}</p>
        </div>
        <div>
          <label class="label" for="calendarLink">Link al calendario</label>
          <input type="text" id="calendarLink" formControlName="calendarLink" />
        </div>

        <div style="grid-column: 1/3" class="input-field">
          <label class="label" for="description">Descrizione</label>
          <textarea
            style="grid-column: 1/3; width: 100%"
            rows="6"
            id="description"
            maxlength="450"
            formControlName="description"
          ></textarea>
        </div>
        <div style="grid-column: 1/3" class="input-field">
          <label class="label" for="note">Note</label>
          <textarea
            style="grid-column: 1/3; width: 100%"
            rows="6"
            id="note"
            maxlength="2048"
            formControlName="notes"
          ></textarea>
        </div>
      </div>
      <!-- *active -->
      <div
        *ngIf="step === 0"
        style="display: flex; gap: 10px; align-items: center; margin-top: 10px"
      >
        <label class="label" for="active">Profilo attivo</label>
        <input type="checkbox" id="active" formControlName="active" />
      </div>
      <!-- -LANGUAGES -->
      <div *ngIf="step === 1" class="grid" formGroupName="lang">
        <div>
          <label class="label" for="title">Titolo di studio</label>
          <select formControlName="title">
            <option value="Medie inferiori">Medie inferiori</option>
            <option value="Medie superiori">Medie superiori</option>
            <option value="Laurea">Laurea</option>
          </select>
        </div>
        <div
          [ngStyle]="{
            opacity: form.get('lang.title')?.value !== 'Laurea' ? '70%' : '100%'
          }"
        >
          <label class="label" for="graduationType">Tipo di laurea</label>
          <input
            type="text"
            id="graduationType"
            formControlName="graduationType"
          />
        </div>
        <div>
          <label class="label" for="english">Inglese</label>
          <select formControlName="english">
            <option value="Non lo parlo">Non lo parlo</option>
            <option value="Sufficiente">Sufficiente</option>
            <option value="Ottimo">Ottimo</option>
            <option value="Madrelingua">Madrelingua</option>
          </select>
        </div>
        <div>
          <label class="label" for="italian">Italiano</label>
          <select formControlName="italian">
            <option value="Non lo parlo">Non lo parlo</option>
            <option value="Sufficiente">Sufficiente</option>
            <option value="Ottimo">Ottimo</option>
            <option value="Madrelingua">Madrelingua</option>
          </select>
        </div>
      </div>
      <!-- -SPECIALITIES -->
      <div
        *ngIf="step === 1"
        style="display: flex; flex-direction: column; margin-top: 20px"
      >
        <label
          style="text-align: start; width: 100%; margin-bottom: 10px"
          class="label"
          for="specialties"
          >Specializzazioni</label
        >
        <!-- *weight_loss -->
        <div style="display: flex; align-items: center; gap: 10px">
          <label
            for="weight_loss"
            style="display: flex; align-items: center; gap: 8px"
          >
            <input
              type="checkbox"
              id="weight_loss"
              formControlName="weight_loss"
            />
            Perdita di peso
          </label>
        </div>
        <!-- *sports_nutrition -->
        <div style="display: flex; align-items: center; gap: 10px">
          <label
            for="sports_nutrition"
            style="display: flex; align-items: center; gap: 8px"
          >
            <input
              type="checkbox"
              id="sports_nutrition"
              formControlName="sports_nutrition"
            />
            Nutrizione sportiva
          </label>
        </div>
        <!-- *pathology_management -->
        <div style="display: flex; align-items: center; gap: 10px">
          <label
            for="pathology_management"
            style="display: flex; align-items: center; gap: 8px"
          >
            <input
              type="checkbox"
              id="pathology_management"
              formControlName="pathology_management"
            />
            Gestione delle patologie
          </label>
        </div>
        <!-- *gastrointestinal_conditions -->
        <div style="display: flex; align-items: center; gap: 10px">
          <label
            for="gastrointestinal_conditions"
            style="display: flex; align-items: center; gap: 8px"
          >
            <input
              type="checkbox"
              id="gastrointestinal_conditions"
              formControlName="gastrointestinal_conditions"
            />
            Condizioni gastrointestinali
          </label>
        </div>
        <!-- *education -->
        <div style="display: flex; align-items: center; gap: 10px">
          <label
            for="education"
            style="display: flex; align-items: center; gap: 8px"
          >
            <input type="checkbox" id="education" formControlName="education" />
            Educazione alimentare
          </label>
        </div>
      </div>
    </form>
    <div class="save-container">
      <button
        class="my-button"
        [class.disabled]="form.invalid"
        [disabled]="form.invalid"
        id="save-button"
        (click)="save(true)"
      >
        Salva
      </button>
      <p *ngIf="form.invalid" class="save-hint red">
        Mancano: {{ getMissingFields().join(', ') }}
      </p>
    </div>
  </div>
</div>

<app-alert
  *ngIf="showAlert"
  (save)="onAlertAction($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione, alcuni dati sono stati modificati!'"
  [message]="'Vuoi salvare le modifiche effettuate?'"
>
</app-alert>

<div
  class="modal"
  id="modal-container"
  *ngIf="showModal"
  (click)="dismiss($event)"
>
  <div class="modal-content">
    <app-image-cropper
      [imageSource]="sanitize(chosenPhoto)"
      (outputEvent)="getCroppedPhoto($event)"
    >
    </app-image-cropper>
    <div class="modal-button-container">
      <button class="secondary-button" (click)="cropperAbort()">Annulla</button>
      <button
        class="secondary-button"
        (click)="uploadImage(finalPhoto, nutritionist.docRef)"
      >
        Conferma
      </button>
    </div>
  </div>
</div>
